import {useSelector} from 'react-redux';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useParamSelector<T = unknown>(
  selector: (...args: any[]) => T,
  ...params: unknown[]
): T {
  return useSelector((state) => selector(state, ...params));
}
